import React, { useCallback, useRef } from 'react';
import { MaterialIcons } from '@iclinic/design-system';

import useLocalVideoToggle from 'features/video-conference/hooks/useLocalVideoToggle';
import ToggleButton from 'features/video-conference/components/TeamComponents/ToggleButton';
import { buttonsTitle, CAMERA } from 'features/video-conference/constants';
import { useVerifyDevicePermission } from 'features/video-conference/hooks/useVerifyDevicePermission';

const { VideocamOutlined, VideocamOffOutlined } = MaterialIcons;

interface Props {
  withLabel?: boolean;
}

export default function CameraButton({ withLabel = false }: Props) {
  const { isVideoEnabled, toggleVideoEnabled } = useLocalVideoToggle();
  const { hasPermission } = useVerifyDevicePermission({
    deviceType: 'camera',
  });

  const lastClickTimeRef = useRef(0);
  const title = isVideoEnabled
    ? buttonsTitle.VIDEO_DISABLED
    : buttonsTitle.VIDEO_ENABLED;

  const toggleVideo = useCallback(() => {
    if (Date.now() - lastClickTimeRef.current > 500) {
      lastClickTimeRef.current = Date.now();
      toggleVideoEnabled();
    }
  }, [toggleVideoEnabled]);

  return (
    <ToggleButton
      onClick={toggleVideo}
      switchedOn={isVideoEnabled && hasPermission}
      variant="error"
      updateOn={false}
      label={withLabel ? CAMERA : ''}
      title={title}
      icon={
        isVideoEnabled && hasPermission ? (
          <VideocamOutlined />
        ) : (
          <VideocamOffOutlined />
        )
      }
      dataGa="telemedicine_camera"
      dataSp="telemedicine_camera"
    />
  );
}
